import React from "react"
import { makeStyles, Paper } from "@material-ui/core"
import Img from "gatsby-image"

const Competence = ({ competence, small }) => {
  const classes = useStyles()
  const classesSmall = useStylesSmall()
  return (
    <Paper elevation={2} className={small ? classesSmall.card : classes.card}>
      <Img
        fluid={competence.image.asset.fluid}
        alt={competence.name}
        className={small ? classesSmall.picto : classes.picto}
      />
      {competence.name}
    </Paper>
  )
}

const useStyles = makeStyles(theme => ({
  card: {
    padding: "1rem",
    fontSize: 20,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "rotate(-2deg)",
    },
  },
  picto: {
    width: 50,
    height: 50,
    marginRight: "1rem",
    display: "inline-block",
  },
}))

const useStylesSmall = makeStyles(theme => ({
  card: {
    padding: "0.5rem",
    fontSize: 15,
    fontWeight: 500,
    lineHeight: "15px",
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
  },
  picto: {
    width: 30,
    height: 30,
    marginRight: "0.75rem",
    display: "inline-block",
  },
}))

export default Competence
